import exportPdf from '../../../Services/exportPdf'

export default () => (dispatch) => {

  dispatch(exportPdf())

}
